
export const AppStore_Link= 'https://apps.apple.com/us/app/%D8%A7%D9%84%D8%AA%D8%B9%D8%A7%D9%88%D9%86%D9%8A%D8%A9-tawuniya/id1639353191';
export const PlayStore_Link='https://play.google.com/store/apps/details?id=com.dxp.TawuniyaInsurance';
